import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { message } from 'antd';

import {
  updateCaps,
  getOrgNameAndCageCode,
  querySupplierCapsForautoComplete,
} from './EditSupplierCapsQL';
import './EditSupplierCaps.scss';

// import Route from 'route-parser';
// Local Deps

export default function EditSupplierHOC(EditSupplierPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
      }).isRequired,
    };

    static initialState = {
      isLoading: true,
      initialValues: {
        additionOptions: '',
        alloy: [],
        approvedSource: [],
        bizClass: [],
        castings: [],
        componentWeight: '',
        coreProcesses: [],
        fsc: [],
        lowVolume: null,
        material: '',
        qualityCerts: [],
        rapidTooling: '',
        simulationCapability: null,
      },
      aluminum: [],
      other: [],
      copper: [],
      iron: [],
      steel: [],
      mmc: [],
      alloy: [],
      material: [],
      orgId: null,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const { auth } = this.props;
      const res = await getOrgNameAndCageCode(auth.organizationId);

      let supCapsResp;
      try {
        supCapsResp = await querySupplierCapsForautoComplete({
          cage: res.organization.cageCode,
        });
      } catch (error) {
        this.setState({
          initialValues: {
            cage: res.organization.cageCode,
            company: res.organization.name,
            additionOptions: '',
            alloy: [],
            approvedSource: [],
            bizClass: [],
            castings: [],
            componentWeight: '',
            coreProcesses: [],
            fsc: [],
            lowVolume: false,
            material: '',
            qualityCerts: [],
            rapidTooling: '',
            simulationCapability: false,
          },
        });

        const initialData = {
          cage: res.organization.cageCode,
          company: res.organization.name,
          additionOptions: '',
          alloy: [],
          approvedSource: [],
          bizClass: [],
          castings: [],
          componentWeight: '',
          coreProcesses: [],
          fsc: [],
          lowVolume: false,
          material: '',
          qualityCerts: [],
          rapidTooling: '',
          simulationCapability: false,
        };

        await updateCaps(initialData);
        supCapsResp = await querySupplierCapsForautoComplete({
          cage: res.organization.cageCode,
        });
      }

      const suppliers = supCapsResp;
      console.log(suppliers);
      this.setState({
        initialValues: {
          cage: res.organization.cageCode,
          company: res.organization.name,
          secondaryOperations: this._getProperty(
            suppliers.supplierAggs,
            'Secondary Operations',
          ),
          alloy: this._getProperty(suppliers.supplierAggs, 'Alloy'),
          approvedSource: this._getProperty(
            suppliers.supplierAggs,
            'Approved Source',
          ),
          bizClass: this._getProperty(
            suppliers.supplierAggs,
            'Business Classification',
          ),
          castings: this._getProperty(
            suppliers.supplierAggs,
            'Casting Process',
          ),
          // componentWeight: suppliers.supplierAggs.componentWeight,
          coreProcesses: this._getProperty(
            suppliers.supplierAggs,
            'Core Process',
          ),
          fsc: this._getProperty(
            suppliers.supplierAggs,
            'Federal Classification',
          ),
          lowVolume: this._getProperty(
            suppliers.supplierAggs,
            'Low Volume',
            true,
          ),

          material: this._getProperty(suppliers.supplierAggs, 'Material Type'),
          qualityCerts: this._getProperty(
            suppliers.supplierAggs,
            'Quality Certification',
          ),
          rapidTooling: this._getProperty(
            suppliers.supplierAggs,
            'Rapid Tooling',
          ),
          simulationCapability: this._getProperty(
            suppliers.supplierAggs,
            'Simulation Capability',
            true,
          ),
        },
      });
    }

    _getProperty = (object, value, checkbox = false) => {
      console.log();
      if (checkbox) {
        if (object && object[value]) {
          const array = Object.keys(object[value]);
          console.log(array);

          return array[0];
        }
        return 'false';
      }
      if (object && object[value]) {
        const array = Object.keys(object[value]);
        return array[0] ? array : [];
      }
      return [];
    };

    _onAlloyChange = async (values, material, formdata) => {
      console.log(material);
      let materialValue;
      switch (material) {
        case 'Aluminum':
          materialValue = 'aluminum';
          break;
        case 'Copper':
          materialValue = 'copper';
          break;
        case 'Iron':
          materialValue = 'iron';
          break;
        case 'Other Non-Ferrous':
          materialValue = 'other';
          break;
        case 'Steel':
          materialValue = 'steel';
          break;
        case 'Metal Matrix Composites':
          materialValue = 'mmc';
          break;

        default:
          break;
      }
      await this.setState({
        [materialValue]: values,
      });
      const initialValues = { ...formdata };

      const array = [
        ...this.state.aluminum,
        ...this.state.copper,
        ...this.state.iron,
        ...this.state.other,
        ...this.state.steel,
        ...this.state.mmc,
      ];
      console.log(array);
      initialValues.alloy = [...new Set(array)];
      this.setState({ initialValues });
    };

    _onMaterialChange = (values, side, formData) => {
      console.log(formData);
      const initialValues = { ...formData };

      const leftAndRight = {
        left: [],
        right: [],
      };

      initialValues.material.map(material => {
        if (
          material === 'Aluminum' ||
          material === 'Copper' ||
          material === 'Iron' ||
          material === 'Cobalt' ||
          material === 'Copper (Brass/Bronze)' ||
          material === 'Lead' ||
          material === 'Magnesium'
        ) {
          leftAndRight.left.push(material);
        } else {
          leftAndRight.right.push(material);
        }
        return material;
      });
      console.log(leftAndRight);
      leftAndRight[side] = values;
      const array = [...leftAndRight.left, ...leftAndRight.right];

      initialValues.material = [...new Set(array)];
      this.setState({ initialValues });
    };

    _setInitalValuesForAlloy = (materialValue, values) => {
      this.setState({
        [materialValue]: values,
      });
    };

    _onSubmit = async formData => {
      console.log(formData);
      const resp = await updateCaps(formData);

      try {
        if (
          resp.updateSupplierCaps.statusCode === '200' &&
          resp.updateSupplierCaps.message === 'success'
        ) {
          message.success(
            'Your Supplier Profile has been successfully updated.',
            2,
          );
        } else {
          message.error('Your Supplier Profile failed to update!', 2);
        }
      } catch (err) {
        message.error('Your Supplier Profile failed to update!', 2);
        console.error('Your Supplier Profile failed to update!', err);
      }

      const that = this;
      that.setState({
        resp,
      });
    };

    render() {
      const { isLoading, initialValues } = this.state;
      const { auth } = this.props;

      const pageProps = {
        auth,
        initialValues,
        onSubmit: this._onSubmit,
        onAlloyChange: this._onAlloyChange,
        onMaterialChange: this._onMaterialChange,
        setInitalValuesForAlloy: this._setInitalValuesForAlloy,
        isLoading,
      };

      return <EditSupplierPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/EditSupplierCapsHOC.jsx